/**
 * This file defines the interfaces for UI Components that are used for displaying information about MODE's entities e.g. User, Device, Home, etc...
 * These components are only UI components without business logic. All they do is get data from props and display them. All logics will be handled
 * by the containers of these components.
 */
/**
 * The base error type that all components can have.
 */
export var BaseCompInputErrorType;
(function (BaseCompInputErrorType) {
    BaseCompInputErrorType["API_CALL"] = "api call";
})(BaseCompInputErrorType || (BaseCompInputErrorType = {}));
// The character we will use as a separator. If an item in the options array is this string instead of an Object then we will
// add a divider to the menu
export const SELECT_INPUT_OPTION_DIVIDER = '-';
export const isSelectInputOption = (obj) => {
    const option = obj;
    return option !== undefined
        && (typeof option === 'object')
        && (typeof option.label === 'string')
        && (!option.icon || typeof option.icon === 'string')
        && (option.disabled === undefined || typeof option.disabled === 'boolean')
        && (option.selected === undefined || typeof option.selected === 'boolean');
};
